<dx-data-grid id="gridContainer" [dataSource]="bills" keyExpr="NO" [columns]="['NO','SYSTEMNAME', 'USERNAME', 'MODE', 'DATETIME', 'GROUPSUMMARY', 'REMARKS']" [showBorders]="true">

</dx-data-grid>
